import { ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/** Route identity belongs to the page, not the currently open child detail. */
export function viewContextKey(route: ActivatedRoute | null | undefined, name: string): string {
  const path = route?.pathFromRoot?.flatMap(item => item.routeConfig?.path ?? item.snapshot.url.map(segment => segment.path).join('/')).join('/') ?? '';
  return `${path}:${name}`;
}

/** The hidden master stays mounted for restoration but is not current content. */
export function viewContextVisible(element: ElementRef<HTMLElement> | null | undefined): boolean {
  return !element?.nativeElement.closest('[inert], [hidden], [aria-hidden="true"]');
}

export function contextIds(values: readonly unknown[]): (string | number)[] {
  return values.filter((value): value is string | number =>
    typeof value === 'string' || typeof value === 'number');
}
